/**
 * One key per logical save, sent as `Idempotency-Key` on the v3 event and v2 event-series saves.
 *
 * The backend journals progress against it, so an automatic retry of the *same* request resumes rather
 * than repeating: if the event was written but its tag categories were not, the retry re-attempts only
 * the tag write. RTK Query's `retry` re-dispatches with identical args, so retries reuse this key for
 * free.
 *
 * A fresh key is minted per user-initiated save, which is why a manual re-save after a failed **create**
 * can produce a second event — see the note on `saveWithRetryOn502` in `eventApi`.
 */
export const newIdempotencyKey = (): string => crypto.randomUUID();
